module.exports = __webpack_public_path__ + "static/media/eStefanik.d4b27bc4.jpeg";